import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeHelper, DateTimeType } from '../date-time-helper';

@Pipe({
  name: 'timeZoneAbbreviation'
})
export class TimeZoneAbbreviationPipe implements PipeTransform {
  transform(dateTime: DateTimeType, timeZoneId: string): string {
    return DateTimeHelper.getTimeZoneAbbreviation(dateTime, timeZoneId);
  }
}